"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailOrderingRoutes = exports.toSalesOrderSummary = exports.retailOrderingPaths = void 0;
const React = require("react");
const react_router_1 = require("react-router");
const ProductsView_1 = require("../../../../../features/base/ordering/views/ProductsView");
const CartSummaryView_1 = require("../../../../../features/base/ordering/views/CartSummaryView");
const SalesOrderSummaryView_1 = require("../../../../../features/base/ordering/views/SalesOrderSummaryView");
const SelectRestaurantView_1 = require("../../../../../features/base/ordering/views/SelectRestaurantView");
exports.retailOrderingPaths = {
    restaurant: "/restaurant",
    menu: "/menu",
    cart: "/cart",
    salesOrderSummary: "/orders/:orderId"
};
const toSalesOrderSummary = (salesOrderId) => `/orders/${salesOrderId}`;
exports.toSalesOrderSummary = toSalesOrderSummary;
const RetailOrderingRoutes = () => (React.createElement(react_router_1.Switch, null,
    React.createElement(react_router_1.Redirect, { from: "/", to: exports.retailOrderingPaths.restaurant, exact: true }),
    React.createElement(react_router_1.Route, { path: exports.retailOrderingPaths.restaurant, exact: true, component: SelectRestaurantView_1.SelectRestaurantView }),
    React.createElement(react_router_1.Route, { path: exports.retailOrderingPaths.menu, exact: true, component: ProductsView_1.ProductsView }),
    React.createElement(react_router_1.Route, { path: exports.retailOrderingPaths.cart, exact: true, component: CartSummaryView_1.CartSummaryView }),
    React.createElement(react_router_1.Route, { path: exports.retailOrderingPaths.salesOrderSummary, exact: true, component: SalesOrderSummaryView_1.SalesOrderSummaryView })));
exports.RetailOrderingRoutes = RetailOrderingRoutes;
//# sourceMappingURL=retailOrderingRoutes.js.map